import { facadeApiV2 as api } from "./baseApiV2";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTours: build.query<GetToursApiResponse, GetToursApiArg>({
      query: (queryArg) => ({
        url: `/tour`,
        params: {
          page_index: queryArg.pageIndex,
          page_size: queryArg.pageSize,
        },
      }),
    }),
    createTour: build.mutation<CreateTourApiResponse, CreateTourApiArg>({
      query: (queryArg) => ({
        url: `/tour`,
        method: "POST",
        body: queryArg.tourRequest,
      }),
    }),
    getTour: build.query<GetTourApiResponse, GetTourApiArg>({
      query: (queryArg) => ({ url: `/tour/${queryArg.id}` }),
    }),
    updateTour: build.mutation<UpdateTourApiResponse, UpdateTourApiArg>({
      query: (queryArg) => ({
        url: `/tour/${queryArg.id}`,
        method: "PUT",
        body: queryArg.tourRequest,
      }),
    }),
    archiveTour: build.mutation<ArchiveTourApiResponse, ArchiveTourApiArg>({
      query: (queryArg) => ({ url: `/tour/${queryArg.id}`, method: "DELETE" }),
    }),
    sendTourToVehicle: build.mutation<
      SendTourToVehicleApiResponse,
      SendTourToVehicleApiArg
    >({
      query: (queryArg) => ({
        url: `/tour/${queryArg.id}/send-to-vehicle`,
        method: "POST",
      }),
    }),
    calculateTourItineraries: build.query<
      CalculateTourItinerariesApiResponse,
      CalculateTourItinerariesApiArg
    >({
      query: (queryArg) => ({
        url: `/tour/${queryArg.id}/itineraries`,
        params: {
          status: queryArg.status,
        },
      }),
    }),
    selectTourItinerary: build.mutation<
      SelectTourItineraryApiResponse,
      SelectTourItineraryApiArg
    >({
      query: (queryArg) => ({
        url: `/tour/${queryArg.id}/itineraries/${queryArg.itineraryId}`,
        method: "POST",
      }),
    }),
    sendTourToOptimizer: build.mutation<
      SendTourToOptimizerApiResponse,
      SendTourToOptimizerApiArg
    >({
      query: (queryArg) => ({
        url: `/tour/${queryArg.id}/send-to-optimizer`,
        method: "POST",
      }),
    }),
    generateTourIsoline: build.query<
      GenerateTourIsolineApiResponse,
      GenerateTourIsolineApiArg
    >({
      query: (queryArg) => ({
        url: `/tour/${queryArg.id}/isoline`,
        params: {
          itineraryId: queryArg.itineraryId,
          waypointId: queryArg.waypointId,
          reference: queryArg.reference,
        },
      }),
    }),
    getChargingStationList: build.query<
      GetChargingStationListApiResponse,
      GetChargingStationListApiArg
    >({
      query: (queryArg) => ({
        url: `/charging-stations`,
        params: {
          queryType: queryArg.queryType,
          bbox: queryArg.bbox,
          chargingPower: queryArg.chargingPower,
          limit: queryArg.limit,
          eMSPOnly: queryArg.eMspOnly,
          truckChargingGrades: queryArg.truckChargingGrades,
          range: queryArg.range,
          paginationToken: queryArg.paginationToken,
        },
      }),
    }),
    getChargingStationMetadataList: build.mutation<
      GetChargingStationMetadataListApiResponse,
      GetChargingStationMetadataListApiArg
    >({
      query: (queryArg) => ({
        url: `/charging-stations/metadata`,
        method: "POST",
        body: queryArg.chargingStationMetadataRequest,
      }),
    }),
    getChargingStationCluster: build.mutation<
      GetChargingStationClusterApiResponse,
      GetChargingStationClusterApiArg
    >({
      query: (queryArg) => ({
        url: `/charging-stations/cluster`,
        method: "POST",
        body: queryArg.chargingStationClusterRequest,
      }),
    }),
    getChargingStation: build.query<
      GetChargingStationApiResponse,
      GetChargingStationApiArg
    >({
      query: (queryArg) => ({
        url: `/charging-stations/${queryArg.id}`,
        params: {
          hereId: queryArg.hereId,
        },
      }),
    }),
    getOperatorList: build.query<
      GetOperatorListApiResponse,
      GetOperatorListApiArg
    >({
      query: () => ({ url: `/operators` }),
    }),
    getVehicleProfileList: build.query<
      GetVehicleProfileListApiResponse,
      GetVehicleProfileListApiArg
    >({
      query: () => ({ url: `/profiles` }),
    }),
    getVehicleProfileDetails: build.query<
      GetVehicleProfileDetailsApiResponse,
      GetVehicleProfileDetailsApiArg
    >({
      query: (queryArg) => ({ url: `/profiles/${queryArg.id}` }),
    }),
    getPermittedAssets: build.query<
      GetPermittedAssetsApiResponse,
      GetPermittedAssetsApiArg
    >({
      query: () => ({ url: `/vehicles` }),
    }),
    getAssetData: build.query<GetAssetDataApiResponse, GetAssetDataApiArg>({
      query: (queryArg) => ({ url: `/vehicles/${queryArg.id}` }),
    }),
    generateIsoline: build.query<
      GenerateIsolineApiResponse,
      GenerateIsolineApiArg
    >({
      query: (queryArg) => ({
        url: `/vehicles/${queryArg.id}/isoline`,
        params: {
          amount: queryArg.amount,
          weight: queryArg.weight,
          isolineMode: queryArg.isolineMode,
          origin: queryArg.origin,
        },
      }),
    }),
    getAssetSubscriptionState: build.query<
      GetAssetSubscriptionStateApiResponse,
      GetAssetSubscriptionStateApiArg
    >({
      query: (queryArg) => ({ url: `/vehicles/${queryArg.id}/subscription` }),
    }),
    getAccountSubscriptionInfo: build.query<
      GetAccountSubscriptionInfoApiResponse,
      GetAccountSubscriptionInfoApiArg
    >({
      query: () => ({ url: `/account/subscription` }),
    }),
    getAccountGroups: build.query<
      GetAccountGroupsApiResponse,
      GetAccountGroupsApiArg
    >({
      query: () => ({ url: `/account/groups` }),
    }),
    getFeatureToggles: build.query<
      GetFeatureTogglesApiResponse,
      GetFeatureTogglesApiArg
    >({
      query: () => ({ url: `/feature-toggles` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as facadeApiV2 };
export type GetToursApiResponse = /** status 200 OK */ TourListResponse;
export type GetToursApiArg = {
  /** Page index for cursor pagination */
  pageIndex?: number;
  /** Number of items per page (min = 1, max = 1000) */
  pageSize?: number;
};
export type CreateTourApiResponse =
  /** status 201 Tour Created */ CreateTourResponse;
export type CreateTourApiArg = {
  tourRequest: TourRequest;
};
export type GetTourApiResponse = /** status 200 OK */ TourResponse;
export type GetTourApiArg = {
  id: string;
};
export type UpdateTourApiResponse =
  /** status 200 Tour Updated */ UpdateTourResponse;
export type UpdateTourApiArg = {
  id: string;
  tourRequest: TourRequest;
};
export type ArchiveTourApiResponse = unknown;
export type ArchiveTourApiArg = {
  id: string;
};
export type SendTourToVehicleApiResponse = unknown;
export type SendTourToVehicleApiArg = {
  id: string;
};
export type CalculateTourItinerariesApiResponse =
  /** status 200 OK */ TourItinerariesResponse;
export type CalculateTourItinerariesApiArg = {
  id: string;
  /** Filter to select Itinerary's status */
  status?: ItineraryStatus;
};
export type SelectTourItineraryApiResponse = unknown;
export type SelectTourItineraryApiArg = {
  id: string;
  /** Tour's Itinerary id */
  itineraryId: string;
};
export type SendTourToOptimizerApiResponse = unknown;
export type SendTourToOptimizerApiArg = {
  id: string;
};
export type GenerateTourIsolineApiResponse =
  /** status 201 OK */ GenerateIsolineResponse;
export type GenerateTourIsolineApiArg = {
  id: string;
  /** Itinerary id */
  itineraryId: string;
  /** Waypoint id */
  waypointId?: number;
  /** Isoline mode where:
    - ORIGIN defines the isoline at the tour's origin
    - DESTINATION defines the isoline at the tour's destination
    - WAYPOINT defines the isoline at the tour's waypoint location
     */
  reference: "ORIGIN" | "DESTINATION" | "WAYPOINT";
};
export type GetChargingStationListApiResponse =
  /** status 200 Successful response */ ChargingStationListResponse;
export type GetChargingStationListApiArg = {
  /** Can be used to filter charging stations by bounding box (using `BBOX`) or by range (using `NEAREST`)
   */
  queryType?: "BBOX" | "NEAREST";
  /** Required if `query_type` is `BBOX`.
    
    Format: `<min_lng>,<min_lat>,<max_lng>,<max_lat>`
    - `min_lng`: Bottom left longitude
    - `min_lat`: Bottom left latitude
    - `max_lng`: Top right longitude
    - `max_lat`: Top right latitude
     */
  bbox?: string;
  /** Can be used to filter charging stations by bounding box.
    
    Format: `<grade>,<grade>` Values:
      - LOW
      - MEDIUM
      - HIGH
     */
  chargingPower?: string;
  /** If `query_type` is not set or `BBOX` then this parameter will configure the amount of
    records to be returned, and if there is more a `pagination_token` will be returned for
    the next pages.
    
    If NEAREST query is specified, then the amount will be respected but no `pagination_token`
    since range search are scoped to a certain area.
     */
  limit?: number;
  /** If set to `true` then only charging stations that are part of the eMSP will be returned.
   */
  eMspOnly?: boolean;
  /** Can be used to filter charging stations by truck grading. Not considered if query_type parameter is set to 'NEAREST'.
    
    Format: `<grade>,<grade>`
    Grades:
    - UNSPECIFIED
    - TRUCK_INCOMPATIBLE
    - TRUCK_LIMITED
    - TRUCK_READY
     */
  truckChargingGrades?: string;
  /** Required if `query_type` is `NEAREST`.
    
    Format: `<lat>,<lng>,r=<radius>`
    - `lat`: Latitude
    - `lng`: Longitude
    - `radius`: Radius in meters (maximum 50km)
     */
  range?: string;
  /** On endpoints that support pagination a token can be provided, if the first page of the pagination
    is requested, this parameter can be omitted.
    
    A pagination token will be supplied on the first request and on subsequent requests, this token
    will change, letting the client know that there are more pages available.
    
    If the last page is reached, the pagination token will be omitted.
     */
  paginationToken?: string;
};
export type GetChargingStationMetadataListApiResponse =
  /** status 200 Successful response */ ChargingStationMetadataListResponse;
export type GetChargingStationMetadataListApiArg = {
  chargingStationMetadataRequest: ChargingStationMetadataRequest;
};
export type GetChargingStationClusterApiResponse =
  /** status 200 Successful response */ ChargingStationListResponse;
export type GetChargingStationClusterApiArg = {
  chargingStationClusterRequest: ChargingStationClusterRequest;
};
export type GetChargingStationApiResponse =
  /** status 200 Successful response */ ChargingStation;
export type GetChargingStationApiArg = {
  id: string;
  hereId?: string;
};
export type GetOperatorListApiResponse =
  /** status 200 Successful response */ OperatorListResponse;
export type GetOperatorListApiArg = void;
export type GetVehicleProfileListApiResponse =
  /** status 200 Returns a list of all available vehicle profiles */ VehicleProfileListItem[];
export type GetVehicleProfileListApiArg = void;
export type GetVehicleProfileDetailsApiResponse =
  /** status 200 Returns a vehicle profile */ VehicleProfileDetails;
export type GetVehicleProfileDetailsApiArg = {
  id: string;
};
export type GetPermittedAssetsApiResponse =
  /** status 200 Returns permitted assets */ PermittedAssetsResponse;
export type GetPermittedAssetsApiArg = void;
export type GetAssetDataApiResponse = /** status 200 OK */ AssetDataResponse;
export type GetAssetDataApiArg = {
  id: string;
};
export type GenerateIsolineApiResponse =
  /** status 200 Isoline Range calculated */ IsolineResponse;
export type GenerateIsolineApiArg = {
  id: string;
  /** Maximum values per isoline request type (should be positive)
    DISTANCE: 1000000 (in meters)
    TIME: 32400 (in seconds)
    CONSUMPTION: EV (228060 in Watt-hour)
     */
  amount: number;
  /** Vehicle total weight in Kg (e.g. 30000) */
  weight: number;
  /** Isoline Calculation Mode
   */
  isolineMode: IsolineMode;
  /** Format: `<lat>,<lng>`
    - `lat`: Latitude
    - `lng`: Longitude
     */
  origin: string;
};
export type GetAssetSubscriptionStateApiResponse =
  /** status 200 Returns current Subscription state */ AssetSubscriptionState;
export type GetAssetSubscriptionStateApiArg = {
  id: string;
};
export type GetAccountSubscriptionInfoApiResponse =
  /** status 200 OK */ AccountSubscriptionInfo;
export type GetAccountSubscriptionInfoApiArg = void;
export type GetAccountGroupsApiResponse = /** status 200 OK */ AccountGroups;
export type GetAccountGroupsApiArg = void;
export type GetFeatureTogglesApiResponse =
  /** status 200 Returns feature toggles */ FeatureToggles;
export type GetFeatureTogglesApiArg = void;
export type Coordinates = {
  latitude: number;
  longitude: number;
};
export type Address = {
  name?: string;
  street: string;
  number?: string;
  city: string;
  region: string;
  countryCode: string;
  postalCode: string;
};
export type TourDeparture = {
  coordinates: Coordinates;
  name: string;
  address: Address;
  desiredDepartureTime?: string;
  initialCargoWeight: number;
};
export type TourArrival = {
  coordinates: Coordinates;
  name: string;
  address: Address;
  desiredArrivalTime?: string;
};
export type ViaWaypoint = {
  type: string;
  address?: Address;
};
export type ChargingStopWaypointDurationSetting = {
  type: string;
  minDuration: number;
  maxDuration: number;
};
export type ChargingStopWaypointTargetSetting = {
  type: string;
  targetBatteryLever: number;
};
export type ChargingStopWaypoint = {
  type: string;
  stationId: string;
  name?: string;
  address?: Address;
  voltage?: number;
  current?: number;
  power?: number;
  supply_type?: Supply_type;
  settings:
    | ({
        type: "DURATION";
      } & ChargingStopWaypointDurationSetting)
    | ({
        type: "TARGET";
      } & ChargingStopWaypointTargetSetting);
};
export type StopoverWaypoint = {
  type: string;
  name?: string;
  address?: Address;
  duration: number;
  weightDelta: number;
};
export type Waypoint = {
  waypointId?: number;
  coordinates?: Coordinates;
  details?:
    | ({
        type: "VIA";
      } & ViaWaypoint)
    | ({
        type: "CHARGING_STOP";
      } & ChargingStopWaypoint)
    | ({
        type: "STOPOVER";
      } & StopoverWaypoint);
};
export type EvSettings = {
  totalBatteryCapacity?: number;
  initialBatteryCapacity?: number;
  maxBatteryCapacity?: number;
  minBatteryCapacity?: number;
  minBatteryCapacityAtDestination?: number;
  auxiliaryConsumption?: number;
  descentRecovery?: number;
  ascentConsumption?: number;
};
export type TourVehicle = {
  vehicleId?: string;
  vehicleProfileId?: string;
  vehicleDeviceId?: string;
  engineType: EngineType;
  vehicleType: VehicleType;
  truckType?: TruckType;
  length: number;
  width: number;
  height: number;
  emptyWeight: number;
  trailerCount: number;
  axlesCount: number;
  trailerAxlesCount: number;
  maxWeightPerAxle?: number;
  maxWeightPerAxleGroup?: number;
  maxSpeedLimit?: number;
  maxCargoWeight?: number;
  tunnelCategory?: TunnelCategory;
  plugType?: PlugType[];
  evSettings?: EvSettings;
  batteryCount?: number;
};
export type GeoAreaCorridor = {
  type: string;
  coordinates?: Coordinates[];
  width?: number;
};
export type GeoAreaBoundingBox = {
  type: string;
  northEast?: Coordinates;
  southWest?: Coordinates;
};
export type GeoAreaPolygon = {
  type: string;
  coordinates?: Coordinates[];
};
export type GeoArea = {
  shape?:
    | ({
        type: "CORRIDOR";
      } & GeoAreaCorridor)
    | ({
        type: "BOUNDING_BOX";
      } & GeoAreaBoundingBox)
    | ({
        type: "POLYGON";
      } & GeoAreaPolygon);
};
export type TourConstraints = {
  areas?: GeoArea[];
  features?: Features[];
  hazardous_classes: HazardousClass[];
};
export type TourCostSettings = {
  vehiclePerKm?: number;
  driverPerHr?: number;
  energyPerKwh?: number;
  currency?: Currency;
};
export type EventCreated = {
  type: string;
  requestedByVehicle?: boolean;
  parentTourId?: string;
};
export type EventUpdated = {
  type: string;
  requestedByVehicle?: boolean;
};
export type EventSynchronizationStarted = {
  type: string;
  vehicleId?: string;
  vehicleDeviceId?: string;
};
export type EventSynchronizationUpdated = {
  type: string;
  eventReceived?: string;
  eventSend?: string;
};
export type EventGuidance = {
  type: string;
};
export type EventCancellation = {
  type: string;
  eventReceived?: string;
  requestedByVehicle?: boolean;
};
export type TourEvent = {
  eventId?: string;
  occurredAt?: string;
  details?:
    | ({
        type: "CREATED";
      } & EventCreated)
    | ({
        type: "UPDATED";
      } & EventUpdated)
    | ({
        type: "SYNCHRONIZATION_STARTED";
      } & EventSynchronizationStarted)
    | ({
        type: "SYNCHRONIZATION_UPDATED";
      } & EventSynchronizationUpdated)
    | ({
        type: "GUIDANCE";
      } & EventGuidance)
    | ({
        type: "CANCELLATION";
      } & EventCancellation);
};
export type TourEvents = {
  timelineEvents?: TourEvent[];
};
export type TourResponse = {
  tourId: string;
  parentTourId?: string;
  revision: number;
  name?: string;
  description?: string;
  status: Status;
  departure: TourDeparture;
  arrival: TourArrival;
  waypoints: Waypoint[];
  vehicle: TourVehicle;
  constraints: TourConstraints;
  optimizationMethod?: OptimizationMethod;
  createAt: string;
  lastUpdate?: string;
  costSettings: TourCostSettings;
  events?: TourEvents;
  isAutomated: boolean;
};
export type TourListResponse = {
  totalCount?: number;
  tours?: TourResponse[];
};
export type ErrorMessage = {
  /** Error code */
  error_code: Error_code;
  /** Additional details about the error */
  message?: string;
};
export type CreateTourResponse = {
  tourId?: string;
};
export type TourRequest = {
  tourId?: string;
  parentTourId?: string;
  name?: string;
  description?: string;
  departure: TourDeparture;
  arrival: TourArrival;
  waypoints: Waypoint[];
  vehicle: TourVehicle;
  constraints: TourConstraints;
  optimizationMethod?: OptimizationMethod;
  costSettings: TourCostSettings;
  isAutomated: boolean;
};
export type UpdateTourResponse = {
  tourId?: string;
};
export type ItinerarySpan = {
  index?: number;
  ev_consumption?: number;
  distance?: number;
  duration?: number;
  street_attributes?: StreetAttributes[];
  truck_attributes?: TruckAttributes[];
  coordinates?: Coordinates[];
};
export type ItinerarySection = {
  sectionId?: number;
  type?: Type;
  departureTime?: string;
  arrivalTime?: string;
  distance?: number;
  duration?: number;
  evConsumption?: number;
  evBatteryCapacityDeparture?: number;
  evBatteryCapacityArrival?: number;
  transitMode?: TransitMode;
  spans?: ItinerarySpan[];
};
export type ItinerarySummary = {
  distance?: number;
  duration?: number;
  evConsumption?: number;
  evChargingDuration?: number;
  vehicleCost?: number;
  driverCost?: number;
  energyCost?: number;
  minTollCost?: number;
  maxTollCost?: number;
  minTotalCost?: number;
  maxTotalCost?: number;
};
export type EventDeparture = {
  type: string;
  coordinates?: Coordinates;
  address?: Address;
  expectedBatteryLevelAtDeparture?: number;
};
export type EventDriving = {
  type: string;
  sectionId?: number;
};
export type EventTransit = {
  type: string;
  sectionId?: number;
};
export type EventIntermediateStop = {
  type: string;
  waypointId?: number;
  coordinates?: Coordinates;
  address?: Address;
  expectedBatteryLevelAtArrival?: number;
  weightDelta?: number;
  duration?: number;
};
export type Operator = {
  id?: string;
  name?: string;
};
export type EventChargeStop = {
  type: string;
  waypointId?: number;
  operator?: Operator;
  stationId?: string;
  stationName?: string;
  coordinates?: Coordinates;
  address?: Address;
  expectedBatteryLevelAtArrival?: number;
  expectedBatteryLevelAtDeparture?: number;
  minDuration?: number;
  maxDuration?: number;
  voltage?: number;
  current?: number;
  power?: number;
  supply_type?: string;
  plug_type?: string;
};
export type EventArrival = {
  type: string;
  coordinates?: Coordinates;
  address?: Address;
  expectedBatteryLevelAtArrival?: number;
};
export type TimelineEvent = {
  eventId?: number;
  occurredAt?: string;
  details?:
    | ({
        type: "DEPARTURE";
      } & EventDeparture)
    | ({
        type: "DRIVING";
      } & EventDriving)
    | ({
        type: "TRANSIT";
      } & EventTransit)
    | ({
        type: "INTERMEDIATE_STOP";
      } & EventIntermediateStop)
    | ({
        type: "CHARGE_STOP";
      } & EventChargeStop)
    | ({
        type: "ARRIVAL";
      } & EventArrival);
};
export type ItineraryEvents = {
  timelineEvents?: TimelineEvent[];
};
export type ItineraryResponse = {
  tourId?: string;
  itineraryId?: string;
  sections?: ItinerarySection[];
  summary?: ItinerarySummary;
  status?: ItineraryStatus;
  events?: ItineraryEvents;
};
export type TourItinerariesResponse = {
  Itineraries?: ItineraryResponse[];
};
export type GenerateIsolineResponse = {
  coordinates?: Coordinates[];
};
export type ConnectorRate = {
  /** Connector price. */
  price?: string;
  /** Price source */
  contractType?: ContractType;
  tariffId?: string;
  currency?: string;
  /** Defines the price for a specific unit, such as per kWh (Energy) or per minute (Time) */
  currencyDimension?: CurrencyDimension;
};
export type Connector = {
  /** Connector ID */
  id?: string;
  /** EVSE ID */
  evse_id?: string;
  /** Connector standard */
  standard?: Standard;
  /** Connector plug type */
  plug_type?: Plug_type;
  /** Describe if power is AC or DC */
  power_type?: Power_type;
  /** Maximum power in kW */
  max_power?: number;
  truck_charging_grade?: number;
  msp_connector_id?: string;
  msp_price_status?: string;
  /** Voltage in V */
  voltage?: number;
  /** Connector's amperage in amp */
  current?: number;
  status?: ConnectorStatus;
  paymentMethodSupported?: string[];
  prices?: ConnectorRate[];
};
export type TimePair = {
  timeTo?: string;
  timeFrom?: string;
};
export type RegularSchedule = {
  dayOfWeek?: string;
  time?: TimePair;
};
export type OpeningHours = {
  open24x7?: boolean;
  chargingWhenClosed?: boolean;
  regularSchedule?: RegularSchedule[];
};
export type ChargePoint = {
  chargePointId?: string;
  parkingScenario?: ParkingScenario;
  supportsRemoteAuthentication?: boolean;
  supportsCreditCard?: boolean;
  canChargeWithTrailer?: boolean;
  blockSeveralParkingSpots?: boolean;
  hasHeightRestriction?: boolean;
  heightRestriction?: number;
  widthRestriction?: number;
  lengthRestriction?: number;
  parkingLotLength?: number;
  parkingLotWidth?: number;
  connectors?: Connector[];
};
export type ChargingStation = {
  id: string;
  tcsId?: string;
  hereId?: string;
  name: string;
  operator: Operator;
  address?: string;
  city?: string;
  postal_code?: string;
  country_code?: string;
  location: Coordinates;
  /** The max power that could be transmitted through one of the connectors in kW. */
  max_power?: number;
  truck_charging_grade?: number;
  support_phone?: string;
  tariffIds?: string[];
  hasShower?: boolean;
  hasToilet?: boolean;
  hasHotel?: boolean;
  hasRestaurant?: boolean;
  hasVideoSurveillance?: boolean;
  hasADRRestrictions?: boolean;
  trailerParking?: boolean;
  hasWeightRestriction?: boolean;
  weightRestriction?: number;
  connectors?: Connector[];
  stationContracts?: StationContracts[];
  otherFacilities?: string[];
  openingHours?: OpeningHours;
  chargePoints?: ChargePoint[];
};
export type ChargingStationListResponse = {
  paginationToken?: string;
  items: ChargingStation[];
};
export type ChargingStationMetadata = {
  id?: string;
  tcsId?: string;
  hereId?: string;
  name?: string;
  operator?: Operator;
  location?: Coordinates;
  address?: Address;
  /** The max power that could be transmitted through one of the connectors in kW. */
  maxPower?: number;
  truckClassification?: TruckClassification;
  numberOfConnectors?: number;
  connectorsPowers?: number[];
  tariffIds?: string[];
  connectorsEvseIds?: string[];
};
export type ChargingStationMetadataListResponse = {
  hasMore?: boolean;
  chargingStations?: ChargingStationMetadata[];
};
export type RangeFilter = {
  center?: Coordinates;
  radius?: number;
};
export type ChargingStationMetadataRequest = {
  queryType: QueryType;
  bbox?: GeoAreaBoundingBox;
  chargingPower?: ChargingPower[];
  pageSize?: number;
  emspOnly?: boolean;
  truckClassification?: TruckClassification[];
  rangeFilter?: RangeFilter;
  pageNumber?: number;
  ids?: string[];
  coordinate_path?: Coordinates[];
};
export type ChargingStationClusterRequest = {
  paginationToken?: string;
  ids: string[];
  limit?: number;
};
export type OperatorListResponse = {
  items: Operator[];
};
export type VehicleProfileListItem = {
  id: string;
  profileName: string;
  engineType?: EngineType2;
};
export type VehicleProfilePackWeight = {
  packs: number;
  weight: number;
};
export type VehicleProfileDetails = {
  id: string;
  profileName: string;
  vehicleType: VehicleType2;
  engineType: EngineType2;
  length: number;
  width: number;
  height: number;
  emptyWeightVehicle: VehicleProfilePackWeight[];
  emptyWeightFreightTrain: VehicleProfilePackWeight[];
  maxFreightTrainWeight: number;
  maxCargoWeight: VehicleProfilePackWeight[];
  maxWeightPerAxle: number;
  maxWeightPerAxleGroup?: number;
  axlesVehicle: number;
  axlesTrailer?: number;
  numberAttachedTrailers: number;
  defaultInstalledBatteryPackCount: number;
  batteryCapacityPerPack: number;
  plugTypes: PlugTypes[];
};
export type AssetSubscriptionState = {
  /** Actual subscription status */
  status: Status2;
  /** Subscription level */
  subscription?: Subscription;
};
export type PermittedAsset = {
  id: string;
  name: string;
  type: string;
  identification?: string;
  identification_type?: string;
  subscription_state: AssetSubscriptionState;
  group_ids: string[];
  /** Manually calculated field (given the presence of electric related events) */
  details_bev?: boolean;
};
export type PermittedAssetsResponse = {
  items: PermittedAsset[];
};
export type Position = {
  latitude?: number;
  longitude?: number;
  /** Height above sea level in meters */
  altitude?: number;
  /** Speed of the device in Km/h */
  speed?: number;
};
export type State = {
  /** Mileage in Km */
  mileage?: number;
  ignition_on?: boolean;
  /** unit in % */
  state_of_charge?: number;
  /** Remaining range of electric vehicles in Km */
  remaining_range?: number;
  /** Energy level in kWh */
  energy_level?: number;
  /** Fuel level in % */
  fuel_level?: number;
  /** Vehicle total weight in Kg */
  weight_total?: number;
};
export type AssetDetails = {
  /** Possible values - diesel, hydrogen, gas or electric */
  fuel_type?: string;
  number_of_axes?: number;
  /** Information collected about the vehicles in a non defined format */
  tires?: string;
  /** Manually calculated field (given the presence of electric related events) */
  details_bev?: boolean;
  curbWeight?: number;
};
export type DrivingAndRestingDetails = {
  /** Max remaining time until the next required break (in seconds) */
  remaining_current_driving_time?: number;
};
export type DriverState = {
  driving_and_resting_details?: DrivingAndRestingDetails;
};
export type TemperatureSummary = {
  /** temperature in Celsius */
  temperature?: number;
  /** Temperature description */
  temperature_description?: string;
  /** Highest temperature for the day in Celsius */
  high_temperature?: string;
  /** Lowest temperature for the day in Celsius */
  low_temperature?: string;
};
export type WindSummary = {
  /** Air description */
  air_description?: string;
  /** Wind speed in km/h */
  wind_speed?: number;
  /** Direction of the wind - North */
  wind_description?: string;
  /** Abbreviation of the direction of the wind - N */
  wind_short_description?: string;
};
export type WeatherSummary = {
  /** Weather description */
  description?: string;
  /** Sky weather description */
  sky_description?: string;
  humidity?: string;
  temperature_summary?: TemperatureSummary;
  wind_summary?: WindSummary;
};
export type BatteryConfiguration = {
  batteryPacksNumber?: number;
  chargePortType?: string[];
  maxChargingCurrent?: number;
  energyManagementType?: string;
  maxPower?: number;
  maxRegenPower?: number;
};
export type AxleConfiguration = {
  number?: number;
  ratio?: number;
};
export type AssetData = {
  /** UUID which represents the asset */
  asset_id: string;
  /** UUID which represents the account */
  account_id: string;
  /** name of the asset */
  name?: string;
  /** asset type (e.g truck, bus, van or trailer) */
  vehicleType?: VehicleType3;
  brand?: string;
  model?: string;
  occurred_at?: string;
  /** Outside temperate provided by HERE weather request */
  temperature?: number;
  position?: Position;
  state?: State;
  details?: AssetDetails;
  driver_state?: DriverState;
  weather?: WeatherSummary;
  batteryConfiguration?: BatteryConfiguration;
  axles?: AxleConfiguration[];
};
export type AssetDataResponse = {
  asset_data?: AssetData;
};
export type IsolineItem = {
  points?: Coordinates[];
};
export type IsolineResponse = {
  items?: IsolineItem[];
};
export type AccountSubscriptionInfo = {
  /** true when at least one asset has the SRP product booked */
  srpSubscribed: boolean;
  /** true when at least one asset has the EMSP product booked */
  emspSubscribed: boolean;
};
export type GroupAccountInfo = {
  id: string;
  name: string;
};
export type AccountGroups = {
  items: GroupAccountInfo[];
};
export type FeatureToggles = {
  [key: string]: boolean | string | number;
};
export enum Status {
  Draft = "DRAFT",
  Negotiating = "NEGOTIATING",
  Synchronized = "SYNCHRONIZED",
  InProgress = "IN_PROGRESS",
  WaitingUpdateAcceptance = "WAITING_UPDATE_ACCEPTANCE",
  DriverCancelled = "DRIVER_CANCELLED",
  DispatcherCancelled = "DISPATCHER_CANCELLED",
  ProductCancelled = "PRODUCT_CANCELLED",
  Completed = "COMPLETED",
  Replaced = "REPLACED",
}
export enum Supply_type {
  AcSingle = "AC_SINGLE",
  AcTriple = "AC_TRIPLE",
  Dc = "DC",
}
export enum EngineType {
  Combustion = "COMBUSTION",
  Electric = "ELECTRIC",
}
export enum VehicleType {
  Truck = "TRUCK",
  PrivateBus = "PRIVATE_BUS",
}
export enum TruckType {
  Tractor = "TRACTOR",
  Truck = "TRUCK",
}
export enum TunnelCategory {
  All = "ALL",
  B = "B",
  C = "C",
  D = "D",
  E = "E",
}
export enum PlugType {
  CcsCombo1 = "CCS_COMBO_1",
  CcsCombo2 = "CCS_COMBO_2",
  Mcs = "MCS",
  GbT = "GB_T",
  Mennekes2 = "MENNEKES_2",
  J17721 = "J1772_1",
  Supercharger = "SUPERCHARGER",
  Chademo = "CHADEMO",
}
export enum Features {
  ControlledHighway = "CONTROLLED_HIGHWAY",
  TollRoad = "TOLL_ROAD",
  Ferry = "FERRY",
  Tunnel = "TUNNEL",
}
export enum HazardousClass {
  Explosive = "EXPLOSIVE",
  Gas = "GAS",
  FlammableLiquid = "FLAMMABLE_LIQUID",
  FlammableSolid = "FLAMMABLE_SOLID",
  OxidizingAgent = "OXIDIZING_AGENT",
  PoisonousInfectious = "POISONOUS_INFECTIOUS",
  Radioactive = "RADIOACTIVE",
  Corrosive = "CORROSIVE",
  PoisonousInhalation = "POISONOUS_INHALATION",
  HarmfulToWater = "HARMFUL_TO_WATER",
  Organic = "ORGANIC",
}
export enum OptimizationMethod {
  Smartest = "SMARTEST",
  Economic = "ECONOMIC",
  Shortest = "SHORTEST",
  Fastest = "FASTEST",
}
export enum Currency {
  Eur = "EUR",
  Bam = "BAM",
  Bgn = "BGN",
  Brl = "BRL",
  Chf = "CHF",
  Czk = "CZK",
  Dkk = "DKK",
  Gbp = "GBP",
  Huf = "HUF",
  Hrk = "HRK",
  Mkd = "MKD",
  Nok = "NOK",
  Pln = "PLN",
  Ron = "RON",
}
export enum Error_code {
  InternalFailure = "INTERNAL_FAILURE",
  NotFound = "NOT_FOUND",
  InvalidAssetId = "INVALID_ASSET_ID",
  NoSubscriptionFound = "NO_SUBSCRIPTION_FOUND",
}
export enum Type {
  Driving = "DRIVING",
  Transit = "TRANSIT",
}
export enum TransitMode {
  HighSpeedTrain = "HIGH_SPEED_TRAIN",
  IntercityTrain = "INTERCITY_TRAIN",
  InterregionalTrain = "INTERREGIONAL_TRAIN",
  RegionalTrain = "REGIONAL_TRAIN",
  CityTrain = "CITY_TRAIN",
  Bus = "BUS",
  Ferry = "FERRY",
  Subway = "SUBWAY",
  LightRail = "LIGHT_RAIL",
  PrivateBus = "PRIVATE_BUS",
  Inclined = "INCLINED",
  Aerial = "AERIAL",
  BusRapid = "BUS_RAPID",
  Monorail = "MONORAIL",
  CarShuttleTrain = "CAR_SHUTTLE_TRAIN",
  Flight = "FLIGHT",
  Unknown = "UNKNOWN",
}
export enum StreetAttributes {
  RightDrivingSide = "RIGHT_DRIVING_SIDE",
  DirtRoad = "DIRT_ROAD",
  Tunnel = "TUNNEL",
  Bridge = "BRIDGE",
  Ramp = "RAMP",
  Motorway = "MOTORWAY",
  Roundabout = "ROUNDABOUT",
  UnderConstruction = "UNDER_CONSTRUCTION",
  DividedRoad = "DIVIDED_ROAD",
  PrivateRoad = "PRIVATE_ROAD",
  ControlledAccessHighway = "CONTROLLED_ACCESS_HIGHWAY",
  BuiltUpArea = "BUILT_UP_AREA",
}
export enum TruckAttributes {
  Open = "OPEN",
  NoThroughTraffic = "NO_THROUGH_TRAFFIC",
  TollRoad = "TOLL_ROAD",
}
export enum ItineraryStatus {
  Current = "CURRENT",
  Next = "NEXT",
  Draft = "DRAFT",
  Archived = "ARCHIVED",
}
export enum Standard {
  Iec62196T1 = "Iec62196T1",
  Iec62196T2 = "Iec62196T2",
  Iec62196T3A = "Iec62196T3a",
  Iec62196T3C = "Iec62196T3c",
  Iec603092Three64 = "Iec603092Three64",
  Iec603092Single16 = "Iec603092Single16",
  Iec603092Three16 = "Iec603092Three16",
  Iec603092Three32 = "Iec603092Three32",
  DomesticA = "DomesticA",
  DomesticB = "DomesticB",
  DomesticC = "DomesticC",
  DomesticD = "DomesticD",
  DomesticE = "DomesticE",
  DomesticF = "DomesticF",
  DomesticG = "DomesticG",
  DomesticH = "DomesticH",
  DomesticI = "DomesticI",
  DomesticJ = "DomesticJ",
  DomesticK = "DomesticK",
  DomesticL = "DomesticL",
  Iec62196T2Combo = "Iec62196T2Combo",
  Chademo = "Chademo",
  Iec62196T1Combo = "Iec62196T1Combo",
  TeslaS = "TeslaS",
  TeslaR = "TeslaR",
  Mcs = "MCS",
  Gbt2023422015 = "Gbt2023422015",
  Unknown = "Unknown",
}
export enum Plug_type {
  Type1Connector = "Type1Connector",
  Type2Connector = "Type2Connector",
  Type2Outlet = "Type2Outlet",
  Type3Outlet = "Type3Outlet",
  TypeEFrenchStandard = "TypeEFrenchStandard",
  TypeFSchuko = "TypeFSchuko",
  TypeGBritishStandard = "TypeGBritishStandard",
  TypeJSwissStandard = "TypeJSwissStandard",
  Ccs2 = "CCS2",
  Ccs1 = "CCS1",
  Chademo = "Chademo",
  Iec60309ThreePhase = "Iec60309ThreePhase",
  Iec60309SinglePhase = "Iec60309SinglePhase",
  Mcs = "MCS",
  Other = "Other",
  Unknown = "Unknown",
}
export enum Power_type {
  Ac = "AC",
  Dc = "DC",
}
export enum ConnectorStatus {
  Available = "Available",
  Faulted = "Faulted",
  Unavailable = "Unavailable",
  Occupied = "Occupied",
  Unknown = "Unknown",
}
export enum ContractType {
  Tcs = "TCS",
  Here = "HERE",
}
export enum CurrencyDimension {
  Energy = "ENERGY",
  Time = "TIME",
  Flat = "FLAT",
  ParkingTime = "PARKING_TIME",
}
export enum StationContracts {
  Tcs = "TCS",
  Here = "HERE",
}
export enum ParkingScenario {
  DriveThrough = "DriveThrough",
  BackwardsDriving = "BackwardsDriving",
  Unknown = "Unknown",
}
export enum TruckClassification {
  TruckReady = "TRUCK_READY",
  TruckLimited = "TRUCK_LIMITED",
  TruckIncompatible = "TRUCK_INCOMPATIBLE",
  Unspecified = "UNSPECIFIED",
}
export enum QueryType {
  Bbox = "BBOX",
  Nearest = "NEAREST",
  Cluster = "CLUSTER",
  OnRoute = "ON_ROUTE",
  All = "ALL",
}
export enum ChargingPower {
  Low = "LOW",
  Medium = "MEDIUM",
  High = "HIGH",
}
export enum EngineType2 {
  Bev = "BEV",
  Ice = "ICE",
}
export enum VehicleType2 {
  StraightTruck = "STRAIGHT_TRUCK",
  Tractor = "TRACTOR",
}
export enum PlugTypes {
  Ccs = "CCS",
  Mcs = "MCS",
}
export enum Status2 {
  Active = "ACTIVE",
  PendingActivation = "PENDING_ACTIVATION",
  PendingCancellation = "PENDING_CANCELLATION",
  Inactive = "INACTIVE",
}
export enum Subscription {
  SrpL10 = "SRP_L10",
  SrpL10Ft = "SRP_L10_FT",
  SrpL11 = "SRP_L11",
  SrpL12 = "SRP_L12",
  SrpL13 = "SRP_L13",
  SrpL14 = "SRP_L14",
  SrpL15 = "SRP_L15",
  NoLevel = "NO_LEVEL",
}
export enum VehicleType3 {
  Truck = "TRUCK",
  Bus = "BUS",
  Van = "VAN",
  Trailer = "TRAILER",
  Undefined = "UNDEFINED",
}
export enum IsolineMode {
  Distance = "DISTANCE",
  Time = "TIME",
  Consumption = "CONSUMPTION",
}
export const {
  useGetToursQuery,
  useLazyGetToursQuery,
  useCreateTourMutation,
  useGetTourQuery,
  useLazyGetTourQuery,
  useUpdateTourMutation,
  useArchiveTourMutation,
  useSendTourToVehicleMutation,
  useCalculateTourItinerariesQuery,
  useLazyCalculateTourItinerariesQuery,
  useSelectTourItineraryMutation,
  useSendTourToOptimizerMutation,
  useGenerateTourIsolineQuery,
  useLazyGenerateTourIsolineQuery,
  useGetChargingStationListQuery,
  useLazyGetChargingStationListQuery,
  useGetChargingStationMetadataListMutation,
  useGetChargingStationClusterMutation,
  useGetChargingStationQuery,
  useLazyGetChargingStationQuery,
  useGetOperatorListQuery,
  useLazyGetOperatorListQuery,
  useGetVehicleProfileListQuery,
  useLazyGetVehicleProfileListQuery,
  useGetVehicleProfileDetailsQuery,
  useLazyGetVehicleProfileDetailsQuery,
  useGetPermittedAssetsQuery,
  useLazyGetPermittedAssetsQuery,
  useGetAssetDataQuery,
  useLazyGetAssetDataQuery,
  useGenerateIsolineQuery,
  useLazyGenerateIsolineQuery,
  useGetAssetSubscriptionStateQuery,
  useLazyGetAssetSubscriptionStateQuery,
  useGetAccountSubscriptionInfoQuery,
  useLazyGetAccountSubscriptionInfoQuery,
  useGetAccountGroupsQuery,
  useLazyGetAccountGroupsQuery,
  useGetFeatureTogglesQuery,
  useLazyGetFeatureTogglesQuery,
} = injectedRtkApi;
